@if (header || isCloseButtonVisible) {
  <header>
    @if (header) {
      <h4>{{ header }}</h4>
    }
    @if (isCloseButtonVisible) {
      <mr-icon-button (click)="modal.close()" label="Close">
        <mr-icon name="close"></mr-icon>
      </mr-icon-button>
    }
  </header>
}
@if (customContentTemplate) {
  <ng-container [ngTemplateOutlet]="customContentTemplate"></ng-container>
} @else {
  <section>
    <ng-content></ng-content>
  </section>
}
@if (actionsTemplate) {
  <footer>
    @if (warningMessage) {
      <p class="warning">{{ warningMessage }}</p>
    }
    <div class="actions">
      <ng-container [ngTemplateOutlet]="actionsTemplate"></ng-container>
    </div>
  </footer>
}
